module.exports = __webpack_public_path__ + "static/ademola-d8b3db359e7c9853b8c1137ded57d0a2.jpg";